// Security configuration
export const SECURITY_CONFIG = {
  // Token storage
  TOKEN_STORAGE_KEY: 'authToken',
  REFRESH_TOKEN_KEY: 'refreshToken',
  
  // Token expiration
  TOKEN_EXPIRY_BUFFER: 5 * 60 * 1000, // 5 minutes buffer
  
  // API timeouts
  REQUEST_TIMEOUT: 30000, // 30 seconds
  
  // CSP and security headers
  CONTENT_SECURITY_POLICY: {
    'connect-src': [
      "'self'",
      'https://api.stripe.com',
      'https://js.stripe.com',
      import.meta.env.VITE_BPE_API_URL,
    ].filter(Boolean).join(' '),
  },
  
  // Allowed origins
  ALLOWED_ORIGINS: [
    'http://localhost:3000',
    'http://localhost:3001',
    'https://deposit.bestprimeenergies.com',
  ],
  
  // Rate limiting
  MAX_LOGIN_ATTEMPTS: 5,
  LOGIN_LOCKOUT_DURATION: 15 * 60 * 1000, // 15 minutes
  
  // Stripe security
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  
  // Feature flags
  ENABLE_2FA: false,
  ENABLE_BIOMETRIC_AUTH: false,
  
  // Data validation
  MAX_UPLOAD_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'application/pdf'],
  
  // Session management
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000, // 24 hours
  IDLE_TIMEOUT: 30 * 60 * 1000, // 30 minutes
};

// Environment-specific security settings
export const getSecurityConfig = () => {
  const env = import.meta.env.VITE_ENVIRONMENT || 'development';
  
  const baseConfig = { ...SECURITY_CONFIG };
  
  if (env === 'production') {
    return {
      ...baseConfig,
      // Production overrides
      SESSION_TIMEOUT: 12 * 60 * 60 * 1000, // 12 hours in production
      IDLE_TIMEOUT: 15 * 60 * 1000, // 15 minutes in production
      ENABLE_2FA: true,
    };
  }
  
  if (env === 'development') {
    return {
      ...baseConfig,
      // Development overrides
      MAX_LOGIN_ATTEMPTS: 10,
      LOGIN_LOCKOUT_DURATION: 5 * 60 * 1000, // 5 minutes in dev
    };
  }
  
  return baseConfig;
};

export default getSecurityConfig();